import api from "./api";

const getAll = () => {
  return api.get("/api/branch/get-all");
};

const saveBranch = (branch, logoFile) => {
  const formData = new FormData();
  Object.keys(branch).forEach((key) => {
    if (branch[key] !== null && branch[key] !== undefined) {
      formData.append(key, branch[key]);
    }
  });
  if (logoFile) {
    formData.append("logo", logoFile);
  }
  return api.post("/api/branch/save", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const deleteBranch = (id) => {
  return api.post("/api/branch/delete", { branchId: id });
};

const updateBranch = (branch, logoFile, removeLogo) => {
  const formData = new FormData();
  Object.keys(branch).forEach((key) => {
    if (branch[key] !== null && branch[key] !== undefined) {
      formData.append(key, branch[key]);
    }
  });
  if (logoFile) {
    formData.append("logo", logoFile);
  }
  if (removeLogo) {
    formData.append("removeLogo", "true");
  }
  return api.post("/api/branch/update", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const BranchService = {
  getAll,
  saveBranch,
  deleteBranch,
  updateBranch,
};

export default BranchService;
